// extracted by mini-css-extract-plugin
export default {"reports-template__modal":"reports-template_reports-template__modal__sHi6N","reports-template__modal__content":"reports-template_reports-template__modal__content__NDnr3"};